export default "__VITE_ASSET__0QI0viNM__";